export const roundCurrency = (amount) => {
  // Round the amount to the specified number of decimal places
  const roundedAmount = Number(amount).toFixed(2)

  return roundedAmount
}
